<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright">
        © {{year}} Tous droits réservés par <b>ittec-P&M</b>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    data() {
      return {
        year: new Date().getFullYear()
      }
    }
  };
</script>
<style scoped>
.copyright {
  text-align: center !important;
  float: none !important;
  width: 100%;
}
</style>
